import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import DetailPage from "./pages/DetailPage";
import PrivateRoute from "./PrivateRoute";
import CategoryPage from "./pages/CategoryPage";
import PostItemPage from "./pages/PostItemPage";
import LoginPage from "./pages/Auth/LoginPage";
import RegisterPage from "./pages/Auth/RegisterPage";
import ProfilePage from "./pages/ProfilePage";
import EditProfilePage from "./pages/EditProfilePage";
import SearchPage from "./pages/SearchPage";
import MyPostsPage from "./pages/MyPostsPage";
import EditPostPage from "./pages/EditPostPage";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import ResetPasswordPage from "./pages/Auth/ResetPasswordPage";
import VerifyEmailPage from "./pages/Auth/VerifyEmailPage";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import HelpPage from "./pages/HelpPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import SafetyPage from "./pages/SafetyPage";
import TipsPage from "./pages/TipsPage";
import CareersPage from "./pages/CareersPage";
import SitemapPage from "./pages/SitemapPage";
import MessagesPage from "./pages/MessagesPage";
import ScrollToTop from "./components/ScrollToTop";
import OrderPage from "./pages/OrderPage";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminPosts from "./pages/admin/AdminPosts";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminSupport from "./pages/admin/AdminSupport";
import { ModalProvider } from "./context/ModalContext";

function App() {
  return (
    <ModalProvider>
      <Router>
        <ScrollToTop />
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/safety" element={<SafetyPage />} />
        <Route path="/tips" element={<TipsPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/sitemap" element={<SitemapPage />} />
        <Route path="/messages" element={<PrivateRoute element={<MessagesPage />} />} />
        <Route path="/detail/:id" element={<DetailPage />} />
        <Route path="/category/:name" element={<CategoryPage />} />
        <Route path="/PostItemPage" element={<PrivateRoute element={<PostItemPage />} />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/profile" element={<PrivateRoute element={<ProfilePage />} />} />
        <Route path="/profile/edit" element={<PrivateRoute element={<EditProfilePage />} />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/my-posts" element={<PrivateRoute element={<MyPostsPage />} />} />
        <Route path="/edit-post/:id" element={<PrivateRoute element={<EditPostPage />} />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/place-order" element={<OrderPage />} />
        <Route path="/admin" element={<PrivateRoute adminOnly={true} element={<AdminDashboard />} />} />
        <Route path="/admin/posts" element={<PrivateRoute adminOnly={true} element={<AdminPosts />} />} />
        <Route path="/admin/orders" element={<PrivateRoute adminOnly={true} element={<AdminOrders />} />} />
        <Route path="/admin/users" element={<PrivateRoute adminOnly={true} element={<AdminUsers />} />} />
        <Route path="/admin/categories" element={<PrivateRoute adminOnly={true} element={<AdminCategories />} />} />
        <Route path="/admin/messages" element={<PrivateRoute adminOnly={true} element={<AdminMessages />} />} />
        <Route path="/admin/support" element={<PrivateRoute adminOnly={true} element={<AdminSupport />} />} />
      </Routes>
    </Router>
  </ModalProvider>
  );
}

export default App;
